export const FEIGNING_FEAR = 'feigningFear'
export const THROWING = 'throwing'
export const NOODLING = 'noodling'
